module.exports = __webpack_public_path__ + "img/IMG_2498-2-2.e5963690.jpg";